export default __webpack_public_path__ + "static/media/cosmonautaPending.aa9ea115.png";